export const ALLOWED_SIZES = ['Thumbnail', 'Small', 'Medium', 'Big', 'Hd'] as const;
export type ImageSize = (typeof ALLOWED_SIZES)[number];

export const IMAGE_SIZE_URL_SUFFIX: Record<ImageSize, string> = {
  Thumbnail: '_Thumbnail',
  Small: '_Small',
  Medium: '_Medium',
  Big: '_Big',
  Hd: '_Hd'
};

export interface UploadImage {
  id: string;
  image: string;
}

export type CreateImageUrl = {
  url: string;
  availableSizes?: string;
  size?: ImageSize;
};
